import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  faCarSide,
  faChalkboardUser,
  faCircleCheck,
  faCircleXmark,
  faClock,
  faIndent,
  faLocationDot,
  faRepeat,
  faStairs,
  faUsers,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { PreventableEvent } from '@progress/kendo-angular-dropdowns';
import { SVGIcon, warningTriangleIcon } from '@progress/kendo-svg-icons';
import {
  Observable,
  combineLatest,
  filter,
  finalize, startWith,
  takeUntil,
  tap
} from 'rxjs';
import { IEPService } from 'src/app/modules/iep/iep-document/services/iep.services';
import { IProviderMeetingDetails } from 'src/app/modules/provider-management/interfaces/pa-meeting-details';
import { LoadingService } from 'src/app/services/loading.service';
import { AbstractComponent } from 'src/app/shared/components/abstract-component';
import { calculateScheduleTimeDiff } from 'src/app/shared/functions/time-diff';
import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';
import { ScheduleMeetingReferenceData } from 'src/app/shared/interfaces/form/schedule-meetiing-reference-data.model';
import { User } from 'src/app/shared/models/user';
import { AuthStore } from 'src/app/stores/auth.store';
import { ReferenceStore } from 'src/app/stores/reference.store';
import {
  SCHEDULE_FIELD_VISIBILITY,
  ScheduleFieldVisibilityConfig,
} from 'src/assets/config/schedule-field-visibility-config';
import { MANDATE_STATUS } from '../../../modules/provider-management/constants/mandates-status.constants';
import { IProviderManagementInfo } from '../../../modules/provider-management/constants/provider-management-routes';
import {
  Occurrences,
  RepeatUntil,
  SessionType,
  WeekDays,
} from '../../../modules/provider-management/enums/schedule-enums';
import { GetMatchingSchedulesResponse } from '../../../modules/provider-management/interfaces/matching-schedule';
import { IMatchingDetailsPayload } from '../../../modules/provider-management/interfaces/matching-student-payload';
import { DashboardPMResponse } from '../../../modules/provider-management/interfaces/pm-dashboard.response';
import { ScheduleTimeRequestModel } from '../../../modules/provider-management/models/schedule-time-request-model';
import { ProviderManagementService } from '../../../modules/provider-management/services/provider-management.service';
import { head } from 'lodash';
import {
  MeetingRecordList,
  MeetingRequestModel,
} from '../../interfaces/iep-attendes.model';
import { ISedmsFormOutput } from '../../interfaces/form/sedms-form-output.model';
import { getStudentSchoolAddressModel } from 'src/app/modules/provider-management/constants/assign-provider-request-model';
import {
  schoolModel,
  StudentAddress,
} from '../../interfaces/school-address-interface';
import { StudentService } from 'src/app/services/student.service';
import { StudentDetails } from '../../interfaces/student-details';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { FormatDate } from 'src/app/core/pipes/format-date.pipe';
import { SERVICE_TYPE_IDS } from 'src/app/modules/provider-management/constants/service-types';
import { ServiceType } from '../../enums/service-types.enum';

@Component({
  selector: 'app-schedule-details',
  templateUrl: './schedule-details.component.html',
  styleUrls: ['./schedule-details.component.scss'],
  standalone: false,
})
export class ScheduleDetailsComponent
  extends AbstractComponent
  implements OnInit, AfterViewInit, OnChanges {
  public chalkBordUser: SVGIcon = this.customFaIcon(faChalkboardUser);
  public clock: SVGIcon = this.customFaIcon(faClock);
  public repeat: SVGIcon = this.customFaIcon(faRepeat);
  public users: SVGIcon = this.customFaIcon(faUsers);
  public locationDot: SVGIcon = this.customFaIcon(faLocationDot);
  public stairs: SVGIcon = this.customFaIcon(faStairs);
  public car: SVGIcon = this.customFaIcon(faCarSide);
  public indent: SVGIcon = this.customFaIcon(faIndent);
  public xMark: SVGIcon = this.customFaIcon(faCircleXmark);
  public checkMark: SVGIcon = this.customFaIcon(faCircleCheck);
  public defaultItemOccurences: IReferenceData;
  public scheduleDetailsForm: FormGroup;
  protected referenceData: ScheduleMeetingReferenceData = {};
  public occurencesEnum: typeof Occurrences = Occurrences;
  public repeatUntil: typeof RepeatUntil = RepeatUntil;
  public disableLocation2: boolean = false;
  @Input() isSchedulerAdd: boolean;
  @Input() addSelectionToGroup: boolean;
  @Input() fromEncounterAttendance: boolean = false;
  @Input() openedFromInlineSchedule: boolean = false;
  public today: Date = this.getToday();
  @Input() indirectType: boolean;
  showWarningDialog: boolean = false;

  previousStartDate: Date | null = null;
  pendingStartDate: Date | null = null;
  requiredLookupData: any;

  disableLocationItem = (args: {
    index: number;
    dataItem: IReferenceData;
  }): boolean => false;
  @Input() public startDate: Date;
  @Input() public editSelectedMandates: DashboardPMResponse[]
  @Input() public startTime: Date;
  @Input() public endTime: Date;
  @Input() public isEditingSession: boolean = undefined;
  @Input() public isNew: boolean = undefined;
  @Input() public isEdititingMeetingSeries: boolean = false;
  @Input() public selectedMandates: DashboardPMResponse[];
  @Input() public macthedStudentDetails: GetMatchingSchedulesResponse;
  @Input() public meetingSk: string;
  @Input() public displayScheduleTimeButton: boolean;
  @Input() public clickEmptySchedule: boolean;
  @Input() public studentsSelected: boolean;
  @Input() public selecteStudentdMandates: any;
  @Input() public selectedMandatesDetails: DashboardPMResponse[];
  @Input() showAbsencePeriodForCreate: boolean = false;
  @Input() recurringMeetingSk: string;
  public studMandates: DashboardPMResponse[] = [];
  private user: User;
  @Input() providerManagementInfo: IProviderManagementInfo;
  public providerAgencies: IReferenceData[] = [];
  public serviceTypeAgencies: IReferenceData[] = [];
  public fieldVisibilityConfig: ScheduleFieldVisibilityConfig =
    SCHEDULE_FIELD_VISIBILITY;
  public duration: string = '0m';
  @Output() mandateInfo: EventEmitter<GetMatchingSchedulesResponse> =
    new EventEmitter<GetMatchingSchedulesResponse>();
  @Input() public schedulerPopupOpen: boolean;
  selectAllLanguages: IReferenceData[];
  optionalAttendeesList: { name: string; email: string; role: string }[] = [];
  requiredAttendeesList: { name: string; email: string; role: string }[] = [];
  selectedIepManadantes: MeetingRecordList | MeetingRecordList[];
  readonly negativeIndex: number = -1;
  readonly indexNumberOne: number = 1;
  readonly indexNumberTwo: number = 2;
  readonly indexNumberThree: number = 3;
  readonly iconNumberFour: number = 4;
  defaultLocationType: IReferenceData = {
    id: null,
    description: 'Location Type',
  };
  studentList: any;
  editMandateIds: string[];
  readonly daily: number = 2;
  readonly doNotRepeat: number = 1;
  readonly endAfter: number = 1;
  readonly endDate: number = 2;
  readonly everyWeekDay: number = 3;
  readonly monthly: number = 5;
  readonly schoolNumber: number = 1;
  readonly studentNumber: number = 2;
  readonly providerAgencyType: number = 3;
  readonly timeSpentEnteringSessionNotes: number = 8;
  readonly timeSpentProgressReporting: number = 9;
  public scheduleLocationsRefernceData: IReferenceData[];
  public showRecordTime: boolean;
  public showAuthorizedTraining: boolean;
  public meetingDetails: IProviderMeetingDetails;
  public showEndData: boolean = false;
  public warningTriangleIcon: SVGIcon = warningTriangleIcon;

  private atLeastOneSelectedValidator: ValidatorFn = (control: AbstractControl) => {
    const value = control.value;
    if (Array.isArray(value) && value.length > 0) {
      return null;
    }
    return { required: true };
  };
  showError: boolean;
  showCrossMarks: boolean;
  studentUser: User;
  studentsList: any[];
  public filteredSessionTypes: IReferenceData[] = [];
  public defaultSessionTypeItem: IReferenceData = { id: 0, description: 'Session Type' };
  showGroupSizeCrossMarks: boolean;
  showServiceStartDateCrossMarks: boolean;
  showEndByDateCrossMarks: boolean;
  showDurationCrossMarks: boolean;
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
  };
  showCrossMandateMarks: boolean;
  formatDate: FormatDate;
  private lastStudentLookupText: string;
  showServiceTypes: boolean = true;

  constructor(
    public referenceStore: ReferenceStore,
    public authoStore: AuthStore,
    public studentService: StudentService,
    private formBuilder: FormBuilder,
    private actiavtedRoute: ActivatedRoute,
    private providerManagementService: ProviderManagementService,
    private authStore: AuthStore,
    public iepService: IEPService<ISedmsFormOutput>,
    public cdRef: ChangeDetectorRef,
    private laodingService: LoadingService
  ) {
    super();
    this.authStore.UserInfo$.subscribe((userInfo: User) => {
      this.studentUser = userInfo;
    });
    this.initializeForm();

    setTimeout(() => {
      this.applySubmissionValidation();
    }, 0);
  }

  ngAfterViewInit(): void {
    const form: FormGroup = this.scheduleDetailsForm;
    const startDateControl = form.get('startDate');
    this.previousStartDate = startDateControl?.value;
    startDateControl?.valueChanges.pipe(startWith(form.get('startDate')?.value))
    .subscribe((date: Date) => {
      if (!date) return;
  
      // Wait until the user has entered a complete date
      const dateInput = document.activeElement as HTMLInputElement;
      const inputValue = dateInput?.value?.replace(/\D/g, '');
        if (dateInput?.value && inputValue.length < 8) {
          return;
        }
  
      const selected = new Date(date);
      selected.setHours(0, 0, 0, 0);
      const today = this.getToday();

      if (selected < today && !this.isSchedulerAdd) {
        this.pendingStartDate = date;
        this.showWarningDialog = true;
        startDateControl.setValue(this.previousStartDate, {
          emitEvent: false
        });
      } else {
        this.previousStartDate = date;
      }
    });
    const updateValidators: (controlName: string, required: boolean) => void = (
      controlName: string,
      required: boolean
    ) => {
      const control: AbstractControl = form.get(controlName);
      if (!control) return;

      if (required) {
        control.setValidators([Validators.required]);
      } else {
        control.clearValidators();
        control.setValue(null);
        // if (control === "occurences") {
        //   control.setValue(head(this.referenceData.occurences))
        // }
      }
      control.updateValueAndValidity({ emitEvent: false });

      // Mark as touched to show red highlight immediately (but not for sessionType, startTime, or endTime on initial load)
      if (required && controlName !== 'sessionType' && controlName !== 'startTime' && controlName !== 'endTime'&& controlName !== 'occurencesCount' && controlName !== 'repeatUntil') control.markAsTouched({ onlySelf: true });
    };

    if (this.isEditingSession) {
      form
        .get('sessionType')
        .valueChanges.pipe(startWith(form.get('sessionType')?.value))
        .subscribe((data: IReferenceData) => {
          if (data?.id === 1) {
            this.scheduleDetailsForm
              .get('providerAgency')
              .setValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('serviceType')
              .setValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('language')
              .setValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('groupSize')
              .setValidators([Validators.required]);
          } else {
            this.scheduleDetailsForm
              .get('providerAgency')
              .removeValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('serviceType')
              .removeValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('language')
              .removeValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('groupSize')
              .removeValidators([Validators.required]);
          }

          if (
            data?.id === this.indexNumberOne ||
            data?.id === this.indexNumberTwo ||
            data?.id === this.indexNumberThree ||
            data?.id === this.iconNumberFour
          ) {
            // this.scheduleDetailsForm
            //   .get('locationType')
            //   .setValidators([Validators.required]);
            // this.scheduleDetailsForm
            //   .get('floorRoom')
            //   .setValidators([Validators.required]);
            // this.scheduleDetailsForm
            //   .get('location')
            //   .setValidators([Validators.required]);
            // this.showAuthorizedTraining = true;
          } else {
            // this.scheduleDetailsForm
            //   .get('locationType')
            //   .removeValidators([Validators.required]);
            // this.scheduleDetailsForm
            //   .get('floorRoom')
            //   .removeValidators([Validators.required]);
            // this.scheduleDetailsForm
            //   .get('location')
            //   .removeValidators([Validators.required]);
            // this.showAuthorizedTraining = false;
          }
          this.showRecordTime = false;

          if (data?.id !== this.indexNumberOne) {
            const sessionTypeValue =
              this.scheduleDetailsForm.get('sessionType')?.value;
            const start = this.scheduleDetailsForm.get('startDate')?.value;
            const startTime = this.scheduleDetailsForm.get('startTime')?.value;
            const endTime = this.scheduleDetailsForm.get('endTime')?.value;
            this.scheduleDetailsForm.reset({}, { emitEvent: false });
            this.scheduleDetailsForm
              .get('sessionType')
              ?.setValue(sessionTypeValue, { emitEvent: false });
            this.scheduleDetailsForm
              .get('startDate')
              ?.setValue(start, { emitEvent: false });
            this.scheduleDetailsForm
              .get('startTime')
              ?.setValue(startTime, { emitEvent: false });
            this.scheduleDetailsForm
              .get('endTime')
              ?.setValue(endTime, { emitEvent: false });
            this.scheduleDetailsForm
              .get('occurences')
              ?.setValue(head(this.referenceData?.occurences), {
                emitEvent: false,
              });

            Object.keys(this.scheduleDetailsForm?.controls).forEach((key) => {
              const control = this.scheduleDetailsForm?.get(key);
              if (key !== 'startDate' && key !== 'startTime' && key !== 'endTime'
                 && key !== 'requiredAttendees'  && key !== 'occurencesCount' && key !== 'repeatUntil') {
                control?.markAsTouched();
                control?.markAsDirty();
              }
              control?.updateValueAndValidity({ emitEvent: false });
            });
          }
          //  else {
          //   if (!this.isNew) {
          //     this.patchSchedilerMeetingDetails();
          //   }
          // }
        });
    }
    else {
      // Occurrences changes
      form.get('occurences').valueChanges.subscribe((data: IReferenceData) => {
        updateValidators(
          'occurencesCount',
          data?.id === this.daily || data?.id === this.monthly
        );
        updateValidators(
          'repeatUntil',
          data?.id !== this.doNotRepeat ||
          data?.id === this.everyWeekDay ||
          data?.id === this.monthly
        );
        updateValidators('monthlyOption', data?.id === this.monthly);
      });

      // Monthly option changes
      form.get('monthlyOption').valueChanges.subscribe((data: string) => {
        updateValidators('dayCount', data === 'onDay');
        updateValidators('weekOrder', data === 'onThe');
        updateValidators('weekDay', data === 'onThe');
      });

      // RepeatUntil changes
      form.get('repeatUntil').valueChanges.subscribe((data: IReferenceData) => {
        this.showEndData = data?.id === this.endDate;
        updateValidators('repeatUntilCount', data?.id === this.endAfter);
        updateValidators('endByDate', data?.id === this.endDate);
      });

      form
        .get('sessionType')
        .valueChanges.pipe(startWith(form.get('sessionType')?.value))
        .subscribe((data: any) => {
          const sessionTypeId = typeof data === 'object' ? data?.id : data;

          if (sessionTypeId === 0 || !sessionTypeId) {
            return;
          }

          form.get('studentMandates')?.setValue(this.studMandates);
          this.applySubmissionValidation();

          if (sessionTypeId === 1) {
            this.scheduleDetailsForm
              .get('providerAgency')
              .setValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('serviceType')
              .setValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('language')
              .setValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('groupSize')
              .setValidators([Validators.required]);
          } else {
            this.scheduleDetailsForm
              .get('providerAgency')
              .removeValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('serviceType')
              .removeValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('language')
              .removeValidators([Validators.required]);
            this.scheduleDetailsForm
              .get('groupSize')
              .removeValidators([Validators.required]);
          }

          if (
            sessionTypeId === 1 ||
            sessionTypeId === 2 ||
            sessionTypeId === 3 ||
            sessionTypeId === 4
          ) {
            // this.scheduleDetailsForm
            //   .get('locationType')
            //   .setValidators([Validators.required]);
            // this.scheduleDetailsForm
            //   .get('floorRoom')
            //   .setValidators([Validators.required]);
            // this.scheduleDetailsForm
            //   .get('location')
            //   .setValidators([Validators.required]);
            // this.showAuthorizedTraining = true;
          } else {
            // this.scheduleDetailsForm
            //   .get('locationType')
            //   .removeValidators([Validators.required]);
            // this.scheduleDetailsForm
            //   .get('floorRoom')
            //   .removeValidators([Validators.required]);
            // this.scheduleDetailsForm
            //   .get('location')
            //   .removeValidators([Validators.required]);
            // this.showAuthorizedTraining = false;
          }
          this.showRecordTime = false;

          if (sessionTypeId !== this.indexNumberOne) {
            const sessionTypeValue =
              this.scheduleDetailsForm.get('sessionType')?.value;
            const start = this.scheduleDetailsForm.get('startDate')?.value;
            const startTime = this.scheduleDetailsForm.get('startTime')?.value;
            const endTime = this.scheduleDetailsForm.get('endTime')?.value;
            const language = this.scheduleDetailsForm.get('language')?.value;
            const serviceType =
              this.scheduleDetailsForm.get('serviceType')?.value;
            this.scheduleDetailsForm.reset({}, { emitEvent: false });
            this.scheduleDetailsForm
              .get('sessionType')
              ?.setValue(sessionTypeValue, { emitEvent: false });
            this.scheduleDetailsForm
              .get('startDate')
              ?.setValue(start, { emitEvent: false });
            this.scheduleDetailsForm
              .get('startTime')
              ?.setValue(startTime, { emitEvent: false });
            this.scheduleDetailsForm
              .get('endTime')
              ?.setValue(endTime, { emitEvent: false });
            this.scheduleDetailsForm
              .get('occurences')
              ?.setValue(head(this.referenceData?.occurences), {
                emitEvent: false,
              });
            this.scheduleDetailsForm
              .get('language')
              ?.setValue(language, { emitEvent: false });
            this.scheduleDetailsForm
              .get('serviceType')
              ?.setValue(serviceType, { emitEvent: false });
            Object.keys(this.scheduleDetailsForm?.controls).forEach((key) => {
              const control = this.scheduleDetailsForm?.get(key);
              if (key !== 'startDate' && key !== 'startTime' && key !== 'endTime' 
                && key !== 'requiredAttendees' && key !== 'occurencesCount ' && key !== 'repeatUntil') {
                control?.markAsTouched();
                control?.markAsDirty();
              }
              control?.updateValueAndValidity({ emitEvent: false });
            });
            this.scheduleDetailsForm.updateValueAndValidity({ emitEvent: false });
            this.cdRef.markForCheck();
          }
          //  else {
          //   if (!this.isNew) {
          //     this.patchSchedilerMeetingDetails();
          //   }
          // }
        });

      form
        .get('studentMandates')
        ?.valueChanges.pipe(startWith(form.get('studentMandates')?.value))
        .subscribe((mandates) => {
          this.disableLocation2 = mandates?.length > 1;

          if (this.disableLocation2) {
            this.disableLocationItem = (args: {
              index: number;
              dataItem: IReferenceData;
            }): boolean => args?.dataItem?.id === 2;
            if (this.scheduleDetailsForm.get('locationType')?.value === null) {
              this.disableLocationItem = (args: {
                index: number;
                dataItem: IReferenceData;
              }): boolean => args?.dataItem?.id === null;
            }
          } else if (
            this.scheduleDetailsForm.get('locationType')?.value === null
          ) {
            this.disableLocationItem = (args: {
              index: number;
              dataItem: IReferenceData;
            }): boolean => args?.dataItem?.id === null;
          } else {
            this.disableLocationItem = (): boolean => false;
          }
        });
      form
        .get('locationType')
        .valueChanges.pipe(startWith(form.get('locationType')?.value))
        .subscribe((locationType: IReferenceData) => {
          if (
            locationType?.id === this.schoolNumber ||
            locationType?.id === this.studentNumber
          ) {
            const selectedStudentSk: string[] = this.selectedMandates?.map(
              (m: DashboardPMResponse) => m?.studentSK
            );
            const payload: getStudentSchoolAddressModel = {
              studentSks: selectedStudentSk,
              locationType: locationType?.id,
            };
            if (selectedStudentSk?.length > 0) {
              this.laodingService.show();
              this.providerManagementService
                .getStudentSchoolAddress(payload).pipe(finalize(() => {
                  this.laodingService?.hide();
                }))
                .subscribe((data) => {
                  if (locationType?.id === this.schoolNumber) {
                    const schooloeAddress = (data as any)?.enrollment?.address;
                    if (schooloeAddress?.streetAddress1 !== null) {
                      const {
                        adminSchoolDBN,
                        adminSchoolName,
                      }: StudentAddress = (data as any)?.enrollment ?? {};

                      const {
                        streetAddress1,
                        city,
                        stateName,
                        zip,
                      }: StudentAddress = schooloeAddress ?? {};

                      // Build address parts safely
                      const parts: string[] = [];

                      // DBN + [SchoolName] block (only if real data exists)
                      if (adminSchoolDBN || adminSchoolName) {
                        const dbnBlock: string =
                          (adminSchoolDBN ? `[${adminSchoolDBN}] ` : '') + // brackets for DBN
                          (adminSchoolName ?? ''); // no brackets for name

                        if (dbnBlock.trim().length > 0) {
                          parts.push(dbnBlock.trim());
                        }
                      }

                      // Address fields (only push if not null)
                      if (streetAddress1) parts.push(streetAddress1);
                      if (city) parts.push(city);
                      if (stateName) parts.push(stateName);
                      if (zip) parts.push(zip);

                      // If no parts → do not bind
                      if (parts.length > 0) {
                        this.scheduleDetailsForm
                          .get('location')
                          ?.setValue(parts.join(', '));
                      } else {
                        this.scheduleDetailsForm.get('location')?.reset();
                        Object.keys(this.scheduleDetailsForm?.controls).forEach((key) => {
                          const control = this.scheduleDetailsForm?.get(key);
                          if (key !== 'startDate' && key !== 'startTime' && key !== 'endTime'
                             && key !== 'occurencesCount' && key !== 'repeatUntil') {
                            control?.markAsTouched();
                            control?.markAsDirty();
                          }
                          control?.updateValueAndValidity({ emitEvent: false });
                        });
                      }
                    }
                  } else if (locationType?.id === this.studentNumber) {
                    const studentAddress = (data as any)?.studentAddress;
                    if (studentAddress?.streetAddress1 !== null) {
                      const { schoolDBN, schoolName }: schoolModel = data ?? {};

                      const {
                        streetAddress1,
                        city,
                        stateName,
                        zip,
                      }: StudentAddress = studentAddress ?? {};

                      // Check if ANY field exists
                      const hasAnyValue: boolean =
                        !!schoolDBN ||
                        !!schoolName ||
                        !!streetAddress1 ||
                        !!city ||
                        !!stateName ||
                        !!zip;

                      if (hasAnyValue) {
                        const parts: string[] = [];

                        // DBN + [SchoolName] block
                        // if (schoolDBN || schoolName) {
                        //   const dbnBlock: string =
                        //     (schoolDBN ? `[${schoolDBN}]` : '') +
                        //     (schoolName ?? '');

                        //   if (dbnBlock.trim().length > 0) {
                        //     parts.push(dbnBlock);
                        //   }
                        // }
                        // Other address fields
                        if (streetAddress1) parts.push(streetAddress1);
                        if (city) parts.push(city);
                        if (stateName) parts.push(stateName);
                        if (zip) parts.push(zip);

                        // Final formatted address
                        const address: string =
                          parts.length > 0 ? parts.join(', ') : null;

                        this.scheduleDetailsForm
                          .get('location')
                          ?.setValue(address);
                      } else {
                        this.scheduleDetailsForm.get('location')?.reset();
                        Object.keys(this.scheduleDetailsForm?.controls).forEach((key) => {
                          const control = this.scheduleDetailsForm?.get(key);
                          if (key !== 'startDate' && key !== 'startTime' && key !== 'endTime' 
                            && key !== 'occurencesCount' && key !== 'repeatUntil') {
                            control?.markAsTouched();
                            control?.markAsDirty();
                          }
                          control?.updateValueAndValidity({ emitEvent: false });
                        });
                      }
                    }
                  }
                  this.cdRef.markForCheck();
                  this.laodingService.hide();
                });
            } else {
              this.scheduleDetailsForm.get('location')?.reset();
              Object.keys(this.scheduleDetailsForm?.controls).forEach((key) => {
                const control = this.scheduleDetailsForm?.get(key);
                if (key !== 'startDate' && key !== 'startTime' && key !== 'endTime' 
                  && key !== 'occurencesCount' && key !== 'repeatUntil') {
                  control?.markAsTouched();
                  control?.markAsDirty();
                }
                control?.updateValueAndValidity({ emitEvent: false });
              });
            }
          }

          if (locationType?.id === this.providerAgencyType) {
            this.laodingService.show();
            this.providerManagementService
              .getProviderAgencyAddress(this.user?.providerSk)
              .subscribe((data: string) => {
                if (data) {
                  this.scheduleDetailsForm.get('location')?.setValue(data);
                }
                this.laodingService.hide();
              });
          } else {
            if (locationType) {
              this.scheduleDetailsForm.get('location')?.reset();
              Object.keys(this.scheduleDetailsForm?.controls).forEach((key) => {
                const control = this.scheduleDetailsForm?.get(key);
                if (key !== 'startDate' && key !== 'startTime' && key !== 'endTime' 
                  && key !== 'occurencesCount' && key !== 'repeatUntil') {
                  control?.markAsTouched();
                  control?.markAsDirty();
                }
                control?.updateValueAndValidity({ emitEvent: false });
              });
            }
          }
          if (locationType?.value === "Other") {
            this.scheduleDetailsForm.get('location')?.reset();
          }
          this.cdRef.markForCheck();
        });
      form.get('sessionType')
        ?.valueChanges.pipe(startWith(form.get('sessionType')?.value))
        .subscribe((sessionType: IReferenceData) => {
          if (sessionType?.id !== 1) {
            if (this.isNew) {
              // Session type changed from Direct encounter
            }
          }

        });


    }
    // Mark all controls as touched except fields that should not show errors on modal load.
    Object.keys(form.controls).forEach(key => {
      if (key !== 'sessionType' && key !== 'startDate' && key !== 'startTime' && key !== 'endTime' && key !== 'requiredAttendees'&& key !== 'occurencesCount' && key !== 'repeatUntil') {
        form.get(key)?.markAsTouched();
      }
    });

    const submissionControl = form.get('submission');
    if (submissionControl) {
      submissionControl.markAsUntouched();
      submissionControl.markAsPristine();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showAbsencePeriodForCreate']) {
      this.applySubmissionValidation();
    }
  }

  get isAbsencePeriodVisible(): boolean {
    return this.showAbsencePeriodForCreate || this.fieldVisibilityConfig.absencePeriod(this);
  }

  private applySubmissionValidation(): void {
    const submissionControl = this.scheduleDetailsForm?.get('submission');
    if (!submissionControl) return;

    if (this.isAbsencePeriodVisible) {
      submissionControl.setValidators([Validators.required]);
      submissionControl.markAsUntouched();
      submissionControl.markAsPristine();
    } else {
      submissionControl.clearValidators();
      submissionControl.setValue(null);
      submissionControl.markAsUntouched();
      submissionControl.markAsPristine();
    }
    submissionControl.updateValueAndValidity();

    // Add required validators for date/time fields without marking them as touched
    this.scheduleDetailsForm?.get('startDate')?.setValidators([Validators.required]);
    this.scheduleDetailsForm?.get('startTime')?.setValidators([Validators.required]);
    this.scheduleDetailsForm?.get('endTime')?.setValidators([Validators.required]);
    this.scheduleDetailsForm?.get('startDate')?.updateValueAndValidity({ emitEvent: false });
    this.scheduleDetailsForm?.get('startTime')?.updateValueAndValidity({ emitEvent: false });
    this.scheduleDetailsForm?.get('endTime')?.updateValueAndValidity({ emitEvent: false });

    this.scheduleDetailsForm.updateValueAndValidity();
  }

  get getControls(): boolean {
    return true;
  }
  get checkValidGradeorAge(): boolean {
    if (this.scheduleDetailsForm.get('studentMandates')?.value <= 0) {
      return false;
    }
    if (!this.selectedMandates?.length && !this.editSelectedMandates?.length) {
      return true;
    }


    const grades: any = this.editSelectedMandates?.length > 0
      ? this.editSelectedMandates : this.selectedMandates.map(s => Number(s.grade))
        .filter(g => !isNaN(g));

    if (grades.length > 1) {
      const minGrade = Math.min(...grades);
      const maxGrade = Math.max(...grades);

      if (maxGrade - minGrade > 3) {
        return false;
      }
    }

    const ages: any = this.editSelectedMandates?.length > 0 ? this.editSelectedMandates : this.selectedMandates.map(m => Number(m.age))
      .filter(a => !isNaN(a) && a >= 0);

    if (ages.length > 1) {
      const minAge = Math.min(...ages);
      const maxAge = Math.max(...ages);

      if ((maxAge - minAge) * 12 > 36) {
        return false;
      }
    }

    return true;
  }

  get isStudentMissingForLog(): boolean {
    if (!this.fromEncounterAttendance ||
      !this.fieldVisibilityConfig.students(this)) {
      return false;
    }

    const ctrl = this.scheduleDetailsForm?.get('students');
    const value = ctrl?.value;

    return !value || (Array.isArray(value) && value.length === 0);
  }

  //TODO: Will remove hardcoded once API is integrated. for student/ optionaal and required attendees multiselect tree dropdowns
  public studentData: {
    id: number;
    text: string;
    mandateDescription: string;
  }[] = [
      { id: 1, text: 'John Doe', mandateDescription: 'Math Mandate' },
      { id: 2, text: 'Jane Smith', mandateDescription: 'Science Mandate' },
    ];

  public data: {
    id: number;
    text: string;
    items: { id: number; text: string }[];
  }[] = [
      {
        text: 'Furniture',
        id: 1,
        items: [
          { text: 'Tables & Chairs', id: 2 },
          { text: 'Sofas', id: 3 },
          { text: 'Occasional Furniture', id: 4 },
        ],
      },
      {
        text: 'Decor',
        id: 5,
        items: [
          { text: 'Bed Linen', id: 6 },
          { text: 'Carpets', id: 7 },
        ],
      },
    ];

  ngOnInit(): void {
    this.authStore.UserInfo$.pipe(filter((user: User) => !!user)).subscribe(
      (userInfo: User) => {
        this.user = userInfo;
      }
    );
    this.laodingService?.show();
    // Load all reference data in parallel
    combineLatest([
      this.getProviderAgenciesObservable(),
      this.getServiceTypesObservable(),
      this.getAllLanguagesObservable(),
    ])
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(() => {
        // Reference data is now loaded
        this.getAllIepManadates();
        this.getReferenceData();
        this.laodingService?.hide();
        if (!this.isNew) {
          this.patchSchedilerMeetingDetails();
        } else {
          this.providerManagementService.bindSelectedScheduleDetails$.subscribe(data => {
            this.scheduleDetailsForm.patchValue(data)
          })
        }
        this.patchEmptySchedule();
        this.applySubmissionValidation();

      });
  }

  private updateFilteredSessionTypes(): void {
    if (this.referenceData.sessionType) {
      let result = this.referenceData.sessionType;

      // Filter out session type id 1 (Direct) when accessed from Encounter Attendance
      if (this.fromEncounterAttendance) {
        result = result.filter(type => type.id !== 1 && type.id !== 5);
      }

      // When opened from inline Schedule, hide id 5 as well
      if (this.openedFromInlineSchedule) {
        result = result.filter(type => type.id !== 5);
      }

      this.filteredSessionTypes = result;
    }
  }

  onAttendeesChange(values: any[]): void {
    if (!Array.isArray(values)) {
      return;
    }

    // keep ONLY child items
    const onlyChildren = values.filter(item => !item.isParent);

    this.scheduleDetailsForm
      .get('requiredAttendees')
      ?.setValue(onlyChildren, { emitEvent: false });
  }
  onOptionalAttendeesChange(values: any[]): void {
    if (!Array.isArray(values)) {
      return;
    }

    // keep ONLY child items
    const onlyChildren = values.filter(item => !item.isParent);

    this.scheduleDetailsForm
      .get('optionalAttendees')
      ?.setValue(onlyChildren, { emitEvent: false });
  }
  patchEmptySchedule(): void {
    if (this.clickEmptySchedule) {
      const scheduleTimeFormModel: ScheduleTimeRequestModel =
        new ScheduleTimeRequestModel({
          startDate: this.startDate,
          startTime: this.startTime,
          endTime: this.endTime,
          endByDate: this.endTime,
        });
      this.scheduleDetailsForm.patchValue(scheduleTimeFormModel);
    } else if (this.schedulerPopupOpen) {
      this.scheduleDetailsForm.get('startDate').setValue(this.startDate);
      this.scheduleDetailsForm.get('startTime').setValue(this.startTime);
      this.scheduleDetailsForm.get('endTime').setValue(this.endTime);
      this.scheduleDetailsForm.get('endByDate').setValue(this.endTime);
    }
  }
  public getAllIepManadates(): void {
    this.laodingService.show();
    const studentSKsList: string[] = this.selectedMandates?.map(
      (m: DashboardPMResponse) => m.studentSK
    ) || [];
    const data: MeetingRequestModel = new MeetingRequestModel({
      studentSKs: studentSKsList,
      meetingType: 4,
    });
    const dbn =
      this.selecteStudentdMandates?.physicalDBN ||
      this.user?.userRoles?.[0]?.locations?.[0]?.dbn;

    if (!dbn) {
      this.laodingService.hide();
      return;
    }
    this.providerManagementService
      .getAllEvaluationAttendess(dbn)
      .pipe(
        takeUntil(this.componentDestroyed),
        finalize(() => this.laodingService.hide())
      )
      .subscribe({
        next: (res: any) => {
          if (res?.attendeesByRole?.length > 0) {
            this.requiredLookupData = this.buildLookup(res.attendeesByRole);
          }
        },
      });
  }
  public buildLookup(source: any[]): any[] {
    if (!Array.isArray(source)) {
      return [];
    }

    return source.flatMap((group, gIndex) => {
      if (!Array.isArray(group.staff)) {
        return [];
      }

      return group.staff.map((att, aIndex) => {
        const fullName = `${att.firstName ?? ''} ${att.lastName ?? ''}`.trim();
        const roleText = group.role ? ` (${group.role})` : '';
        return {
          id: `${att.email ?? `item-${gIndex}-${aIndex}`}`,
          text: `${fullName}${roleText}`,
          email: att.email,
          isParent: false
        };
      });
    });
  }

  /**
   * Get provider agencies as observable (for data loading sequencing)
   */
  private getProviderAgenciesObservable(): Observable<IReferenceData[]> {
    return this.providerManagementService
      .getAgencyProvider(this.user.providerSk)
      .pipe(
        takeUntil(this.componentDestroyed),
        tap((res: IReferenceData[]) => {
          this.providerAgencies = res;
          const data: IReferenceData = head(res)
          this.scheduleDetailsForm.get('providerAgency')?.setValue(data?.id ? data?.description : data);
          this.scheduleDetailsForm.get('providerAgency')?.disable();
        })
      );
  }

  /**
   * Get service types as observable (for data loading sequencing)
   */
  private getServiceTypesObservable(): Observable<IReferenceData[]> {
    return this.referenceStore.rServiceType$
      .pipe(
        takeUntil(this.componentDestroyed),
        tap((res: IReferenceData[]) => {
          this.serviceTypeAgencies = res;
        })
      );
  }

  /**
   * Get all languages as observable (for data loading sequencing)
   */
  private getAllLanguagesObservable(): Observable<IReferenceData[]> {
    return this.referenceStore.language$.pipe(
      takeUntil(this.componentDestroyed),
      tap((res: IReferenceData[]) => {
        this.selectAllLanguages = res;
      })
    );
  }

  // getAllLanguages(): void {
  //   this.laodingService.show();
  //   this.referenceStore.language$.subscribe((data: IReferenceData[]) => {
  //     this.selectAllLanguages = data;
  //     this.laodingService.hide();

  //   });
  // }
  // getServiceTypes(): void {
  //   this.laodingService.show();
  //   this.referenceStore.rServiceType$.subscribe((data: IReferenceData[]) => {
  //     this.serviceTypeAgencies = data;
  //     this.laodingService.hide();

  //   });
  // }
  get checkValidLanguages(): boolean {
    if (this.selectedMandates || this.editSelectedMandates?.length > 0) {
      const result: boolean =
        [...new Set(this.editSelectedMandates?.length > 0 ? this.editSelectedMandates.map((d) => d.mandateLanguageID) :
          this.selectedMandates?.map((d) => d.mandateLanguageID))]
          .length === 1
          ? true
          : false;
      return result;
    } else {
      return true;
    }
  }

  // get checkValidDuration(): boolean {

  //   let durationMinutes = 0;
  //   if (this.duration.endsWith('m')) {
  //     durationMinutes = parseInt(this.duration, 10);
  //   } else if (this.duration.endsWith('h')) {
  //     durationMinutes = parseInt(this.duration, 10) * 60;
  //   } else if (this.duration.endsWith('d')) {
  //     durationMinutes = parseInt(this.duration, 10) * 24 * 60;
  //   }

  //   if (durationMinutes <= 0) {
  //     return true; 
  //   }

  //   return this.validateMeetingDuration(durationMinutes, this.selectedMandates);
  // }

  get hasInvalidTimeRange(): boolean {
    const startTime = this.scheduleDetailsForm?.get('startTime')?.value;
    const endTime = this.scheduleDetailsForm?.get('endTime')?.value;

    if (!startTime || !endTime) {
      return false;
    }

    const start = new Date(startTime);
    const end = new Date(endTime);

    return end.getTime() < start.getTime();
  }

  get checkValidDuration(): boolean {
    const duration: number = this.removeUnits(this.duration?.toString() || '0');

    if (!this.selectedMandates?.length && !this.editSelectedMandates?.length) {
      return true;
    }

    const mandates =
      this.editSelectedMandates?.length > 0
        ? this.editSelectedMandates
        : this.selectedMandates;

    this.showDurationCrossMarks = duration > 0;

    return this.validateMeetingDuration(duration, mandates);
  }
  private removeUnits(value: string): number {
    if (!value) return 0;

    const hourMatch = value.match(/(\d+)\s*h/i);
    const minuteMatch = value.match(/(\d+)\s*m/i);

    const hours = hourMatch ? Number(hourMatch[1]) : 0;
    const minutes = minuteMatch ? Number(minuteMatch[1]) : 0;

    return hours * 60 + minutes;
  }
  get checkValidServiceTypes(): boolean {
    if (this.scheduleDetailsForm.get('serviceType')?.value?.id !== this.indexNumberThree) {
      if (this.selectedMandates || this.editSelectedMandates?.length > 0) {
        const result: boolean =
          [...new Set(this.editSelectedMandates?.length > 0 ? this.editSelectedMandates.map((d) => d.serviceTypeID) :
            this.selectedMandates?.map((d) => d.serviceTypeID))]
            .length === 1
            ? true
            : false;
        return result;
      } else {
        return true;
      }
    }
    else {
      this.showServiceTypes = false;
      return true;
    }
  }

  isPara(row: DashboardPMResponse): boolean {
    return row ? SERVICE_TYPE_IDS.includes(row.serviceTypeID) : false;
  }

  get checkGroupeSize(): boolean {

    if (this.scheduleDetailsForm.get('groupSize')?.value &&
      this.scheduleDetailsForm.get('groupSize')?.value !== '') {
      this.showGroupSizeCrossMarks = true;
      if (this.selectedMandates?.length <=
        Number(this.scheduleDetailsForm.get('groupSize').value)) {
        return true;
      } else if (this.selectedMandates?.length > 2) {
        const userSize: number = Number(this.scheduleDetailsForm.get('groupSize').value) || 0;
        const mandates = this.editSelectedMandates?.length > 0 ? this.editSelectedMandates : this.selectedMandates;
        return mandates?.every((m: DashboardPMResponse) => userSize < Number(m.groupSize));
      }
      else if (this.selectedMandates?.length <= 2) {
        return true;
      }
      else {
        return false;
      }
    } else {
      this.showGroupSizeCrossMarks = false;
      return false;
    }

    // if (!this.selectedMandates?.length) {
    //   return true;
    // }
    // const userSize: number = Number(this.scheduleDetailsForm.get('groupSize')?.value) || 0;
    // const isUserGroupSizeValid = this.selectedMandates.every(
    //   (m: DashboardPMResponse) => userSize <= Number(m.groupSize));

    // if (!isUserGroupSizeValid) {
    //   return false;
    // }
    // const studentCount = this.selectedMandates.length;
    // const mandateGroupSizes = this.selectedMandates.map(m => Number(m.groupSize)).filter(g => !isNaN(g) && g > 0);

    // if (!mandateGroupSizes.length) {
    //   return true;
    // }
    // const minGroupSize = Math.min(...mandateGroupSizes);
    // if (studentCount > minGroupSize || studentCount < userSize) {
    //   return false;
    // }

    // return true;
  }


  private parseDate(value: string | Date): Date | null {
    if (!value) return null;

    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }

    if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
      const [dd, mm, yyyy] = value.split('-').map(Number);
      return new Date(yyyy, mm - 1, dd);
    }

    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
      const [mm, dd, yyyy] = value.split('/').map(Number);
      return new Date(yyyy, mm - 1, dd);
    }

    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  get checkValidServiceStartDate(): boolean {
    const sessionTypeValue = this.scheduleDetailsForm.get('sessionType')?.value;
    const sessionTypeId = typeof sessionTypeValue === 'object' ? sessionTypeValue?.id : sessionTypeValue;
    if (this.scheduleDetailsForm.get('startDate')?.value &&
      sessionTypeId === this.indexNumberOne) {
      this.showServiceStartDateCrossMarks = true;
    }
    if (this.selectedMandates?.length > 0 || this.editSelectedMandates?.length > 0) {
      const enteredDateStr: string = this.scheduleDetailsForm.get('startDate')?.value;
      if (!enteredDateStr) return false;
      const enteredDate: Date = new Date(enteredDateStr);
      const mandates = this.editSelectedMandates?.length > 0 ? this.editSelectedMandates : this.selectedMandates;
      return mandates?.some((m: DashboardPMResponse) => {
        const assignment: DashboardPMResponse = m;
        const formattedDate = new Date(assignment.assignmentStartDate).toLocaleDateString('en-US');
        if (!assignment?.assignmentStartDate) return false;
        const assignmentStart: Date = new Date(formattedDate);
        return enteredDate > assignmentStart;
      });
    }
    else {
      return true
    }
    // const scheduledStartDate = this.scheduleDetailsForm.get('startDate')?.value;
    // if (!scheduledStartDate || !this.selectedMandates?.length) {
    //   return true;
    // }

    // const scheduledDate = this.parseDate(scheduledStartDate);
    // if (!scheduledDate) return false;

    // const startDates = this.selectedMandates
    //   .map(m => this.parseDate(m.serviceStartDate))
    //   .filter((d): d is Date => !!d);

    // const endDates = this.selectedMandates
    //   .map(m => this.parseDate(m.serviceEndDate))
    //   .filter((d): d is Date => !!d);

    // if (!startDates.length || !endDates.length) {
    //   return true;
    // }
    // const latestStartDate = new Date(Math.max(...startDates.map(d => d.getTime())));
    // const earliestEndDate = new Date(Math.min(...endDates.map(d => d.getTime())));

    // return scheduledDate >= latestStartDate && scheduledDate <= earliestEndDate;
  }


  get checkAssignmentEndDate(): boolean {
    const sessionTypeValue = this.scheduleDetailsForm.get('sessionType')?.value;
    const sessionTypeId = typeof sessionTypeValue === 'object' ? sessionTypeValue?.id : sessionTypeValue;
    if (this.scheduleDetailsForm.get('endByDate')?.value &&
      sessionTypeId === this.indexNumberOne) {
      this.showEndByDateCrossMarks = true;
    }
    if (this.selectedMandates?.length > 0 || this.editSelectedMandates?.length > 0) {

      const enteredDateStr: string =
        this.scheduleDetailsForm.get('endByDate')?.value;

      if (!enteredDateStr) return false;

      const enteredDate: Date = new Date(enteredDateStr);
      enteredDate.setHours(0, 0, 0, 0);

      const mandates = this.editSelectedMandates?.length > 0 ? this.editSelectedMandates : this.selectedMandates;
      return mandates?.every((m: DashboardPMResponse) => {
        const endDateStr = m?.serviceEndDate;
        if (!endDateStr) {
          return true;
        }
        let assignmentEnd: Date;
        if (endDateStr.includes('-')) {
          const [day, month, year] = endDateStr.split('-').map(Number);
          assignmentEnd = new Date(year, month - 1, day);
        } else if (endDateStr.includes('/')) {
          const [month, day, year] = endDateStr.split('/').map(Number);
          assignmentEnd = new Date(year, month - 1, day);
        } else {
          assignmentEnd = new Date(endDateStr);
        }

        if (isNaN(assignmentEnd.getTime())) {
          return false;
        }
        assignmentEnd.setHours(0, 0, 0, 0);
        return enteredDate <= assignmentEnd;
      });
    }
    else {
      return true;
    }
  }


  initWatches(): void {
    //FormControls:
    const occurencesControl: FormControl = this.scheduleDetailsForm?.get(
      'occurences'
    ) as FormControl;
    const sessionType: FormControl = this.scheduleDetailsForm?.get(
      'sessionType'
    ) as FormControl;
    const studentMandatesControl: FormControl = this.scheduleDetailsForm?.get(
      'studentMandates'
    ) as FormControl;
    const languageControl: FormControl = this.scheduleDetailsForm?.get(
      'language'
    ) as FormControl;
    const groupSizeControl: FormControl = this.scheduleDetailsForm?.get(
      'groupSize'
    ) as FormControl;
    const serviceTypeControl: FormControl = this.scheduleDetailsForm?.get(
      'serviceType'
    ) as FormControl;
    const providerAgencyControl: FormControl = this.scheduleDetailsForm?.get(
      'providerAgency'
    ) as FormControl;
    const startTimeControl: FormControl = this.scheduleDetailsForm?.get(
      'startTime'
    ) as FormControl;
    const endTimeControl: FormControl = this.scheduleDetailsForm?.get(
      'endTime'
    ) as FormControl;
    const dayCountControl: FormControl = this.scheduleDetailsForm?.get(
      'dayCount'
    ) as FormControl;
    const weekOrderControl: FormControl = this.scheduleDetailsForm?.get(
      'weekOrder'
    ) as FormControl;
    const weekDayControl: FormControl = this.scheduleDetailsForm?.get(
      'weekDay'
    ) as FormControl;
    const monthlyOptionControl: FormControl = this.scheduleDetailsForm?.get(
      'monthlyOption'
    ) as FormControl;
    const yearlyOptionControl: FormControl = this.scheduleDetailsForm?.get(
      'yearlyOption'
    ) as FormControl;
    const monthOfYearControl: FormControl = this.scheduleDetailsForm?.get(
      'monthOfYear'
    ) as FormControl;
    const monthOfYearAltControl: FormControl = this.scheduleDetailsForm?.get(
      'monthOfYearAlt'
    ) as FormControl;


    this.scheduleDetailsForm.get('sessionType')?.valueChanges
      .pipe(takeUntil(this.componentDestroyed),
        startWith(this.scheduleDetailsForm.get('sessionType')?.value))
      .subscribe((data: any) => {
        const sessionTypeId = typeof data === 'object' ? data?.id : data;

        if (sessionTypeId === 0 || !sessionTypeId) {
          return;
        }

        this.applySubmissionValidation();

        if (sessionTypeId === this.indexNumberOne) {
          this.showCrossMarks = true;
          this.showCrossMandateMarks = true;
        } else {
          this.showCrossMarks = false;
          this.showGroupSizeCrossMarks = false;
          this.showServiceStartDateCrossMarks = false;
          this.showDurationCrossMarks = false;
          this.showEndByDateCrossMarks = false;
          this.showCrossMandateMarks = false;
        }
        if (sessionTypeId === 2 || sessionTypeId === 3 || sessionTypeId === 4) {
          this.scheduleDetailsForm.get('requiredAttendees').setValidators([Validators.required])
          this.scheduleDetailsForm.updateValueAndValidity({ emitEvent: false })

        } else {
          this.scheduleDetailsForm.get('requiredAttendees').clearValidators()
          this.scheduleDetailsForm.updateValueAndValidity({ emitEvent: false });
          this.scheduleDetailsForm.get('requiredAttendees').setValue(null);
          this.scheduleDetailsForm.get('requiredAttendees').markAsUntouched();
          this.scheduleDetailsForm.get('requiredAttendees').markAsPristine();
          this.cdRef?.detectChanges();
        }
        if (sessionTypeId !== this.indexNumberOne) {

        } else {
          this.getAllIepManadates();
        }

      });
    this.scheduleDetailsForm.get('repeatUntil')?.valueChanges
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((data: IReferenceData) => {
        if (data?.id === undefined || data?.id === 1 || data?.id === 2 || data?.id === 3 || data?.id === 4 || data?.id === 5) {
          this.showEndByDateCrossMarks = false;
        }

      })
    this.scheduleDetailsForm.get('studentMandates')?.valueChanges
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((data) => {
        if (data?.length <= 0) {
          this.showCrossMandateMarks = true;
        }

      })

    this.scheduleDetailsForm.get('occurences')?.valueChanges
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((data: IReferenceData) => {
        if (data?.id !== 4) {
          this.providerManagementService.setIsWeekySelected(false);
          this.showError = false;
        }

      })

    //Reference Data:
    const occurencesList: IReferenceData[] = this.referenceData.occurences;
    const sesssionTypelist: IReferenceData[] = this.referenceData.sessionType;

    const doNotRepeat: IReferenceData = occurencesList.find(
      (res: IReferenceData) => res.id === Occurrences.DoNotRepeat
    );
    if (this.isNew) {
      occurencesControl?.setValue(doNotRepeat); //Default bind Do Not Repeat;
    }

    occurencesControl?.valueChanges
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((value: IReferenceData) => {
        this.handleDisable(
          dayCountControl,
          weekDayControl,
          weekOrderControl,
          monthOfYearControl,
          monthOfYearAltControl
        );
        monthlyOptionControl?.reset();
        yearlyOptionControl?.reset();
        let selectedWeekDays: number[] = [];

        if (value?.id === Occurrences.EveryWeekday) {
          selectedWeekDays = [
            WeekDays.Monday,
            WeekDays.Tuesday,
            WeekDays.Wednesday,
            WeekDays.Thursday,
            WeekDays.Friday,
          ]; // Monday to Friday
        } else if (value?.id === Occurrences.Weekly) {
          selectedWeekDays = [WeekDays.Monday]; // Monday only
        }

        this.scheduleDetailsForm.get('weekDayChip')?.setValue(selectedWeekDays);
      });

    combineLatest([
      monthlyOptionControl.valueChanges.pipe(
        startWith(monthlyOptionControl.value)
      ),
      yearlyOptionControl.valueChanges.pipe(
        startWith(yearlyOptionControl.value)
      ),
    ])
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([monthlyValue, yearlyValue]: [string, string]) => {
        // Clear everything first
        this.handleDisable(
          dayCountControl,
          weekDayControl,
          weekOrderControl,
          monthOfYearControl,
          monthOfYearAltControl
        );

        // apply based on monthly
        if (monthlyValue === 'onDay') {
          dayCountControl.enable();
          weekDayControl.disable();
          weekOrderControl.disable();
        } else if (monthlyValue === 'onThe') {
          weekDayControl.enable();
          weekOrderControl.enable();
          dayCountControl.disable();
        }

        // apply based on yearly
        if (yearlyValue === 'yearOn') {
          dayCountControl.enable();
          monthOfYearControl.enable();
          weekDayControl.disable();
          weekOrderControl.disable();
          monthOfYearAltControl.disable();
        } else if (yearlyValue === 'yearOnThe') {
          dayCountControl.disable();
          weekDayControl.enable();
          weekOrderControl.enable();
          monthOfYearAltControl.enable();
        }
        // Update value & validity
        dayCountControl.updateValueAndValidity({ emitEvent: false });
        weekDayControl.updateValueAndValidity({ emitEvent: false });
        weekOrderControl.updateValueAndValidity({ emitEvent: false });
        monthOfYearControl.updateValueAndValidity({ emitEvent: false });
        monthOfYearAltControl.updateValueAndValidity({ emitEvent: false });
      });

    //Prepopulate Student/ Mandates & Session Type
    this.studMandates = this.selectedMandates;
    const awaitingServiceConfirmSection: boolean =
      this.providerManagementInfo?.statusID ===
      MANDATE_STATUS.AwaitingServiceConfirmation;
    const receivingConfirmSection: boolean =
      this.providerManagementInfo?.statusID === MANDATE_STATUS.Receiving;
    const allMandatesSection: boolean =
      this.providerManagementInfo?.statusID === MANDATE_STATUS.AllMandates;
    if (awaitingServiceConfirmSection || allMandatesSection || receivingConfirmSection) {
      const relatedService: IReferenceData = sesssionTypelist.find(
        (res: IReferenceData) =>
          res.id === SessionType.RelatedServicesAppointment
      );
      // Only auto-set the session type when editing an existing record.
      // Leave the control null for new forms so the placeholder displays.
      if (!this.isNew) {
        sessionType.setValue(relatedService);
      }
      studentMandatesControl?.setValue(this.studMandates);
      // providerAgencyControl?.setValue(this.studMandates);
      this.studentMandateDetails(
        languageControl,
        serviceTypeControl,
        groupSizeControl,
        providerAgencyControl
      );
    }


    //Get the time difference
    combineLatest([
      startTimeControl?.valueChanges.pipe(startWith(startTimeControl?.value)),
      endTimeControl?.valueChanges.pipe(startWith(endTimeControl?.value)),
    ]).subscribe(([start, end]: [Date | string, Date | string]) => {
      if (start && end) {
        const duration: string = calculateScheduleTimeDiff(start, end);
        this.duration = duration;
      }
    });
  }

  onStudentFilterChange(text: string): void {
    this.studentsList = [];

    if (text?.length === 9) {
      this.laodingService.show();
      // this.scheduleDetailsForm.get('students')?.valueChanges
      //   .pipe(takeUntil(this.componentDestroyed), startWith(this.scheduleDetailsForm.get('students')?.value))
      //   .subscribe((data) => {
      this.laodingService.show();
      this.studentService.studentDetailsById(text).pipe(finalize(() => this.laodingService.hide())).subscribe((response: StudentDetails) => {
        const student: StudentDetails = response; // your API object

        this.studentList = [
          {
            studentName: `${student.firstName} ${student.lastName} (${student.nycId})`,
            nycId: student.nycId,
            studentSK: student.studentSk,
          }
        ];
        this.providerManagementService
          .getAllEvaluationAttendess(response?.schoolDBN)
          .pipe(
            takeUntil(this.componentDestroyed),
            finalize(() => this.laodingService.hide())
          )
          .subscribe({
            next: (res: any) => {
              if (res?.attendeesByRole?.length > 0) {
                this.requiredLookupData = this.buildLookup(res.attendeesByRole);
              }
              this.laodingService.hide();
            },
          });
      });
      // })
    } else {
      this.studentsList = [];
    }
  }

  private validateMeetingDuration(
    meetingDuration: number,
    mandates: any[]
  ): boolean {
    if (!mandates?.length || meetingDuration <= 0) {
      return false;
    }

    const exemptServiceTypes = new Set<number>([
      905, 911, 912, 913, 923, 925, 916,
      31, 32, 33, 34, 35, 36, 37
    ]);

    // Separate exempt and non-exempt mandates
    const nonExemptMandates = mandates.filter(
      m => !exemptServiceTypes.has(m.serviceTypeID)
    );

    //  Always enforce global cap
    if (meetingDuration > 99) {
      return false;
    }

    //  If all mandates are exempt → allow (optional business rule)
    if (!nonExemptMandates.length) {
      return true;
    }

    const durations = nonExemptMandates
      .map(m => Number(m.duration))
      .filter(d => !isNaN(d) && d > 0);

    if (!durations.length) {
      return false;
    }

    const minDuration = Math.min(...durations);
    const maxDuration = Math.max(...durations);

    return meetingDuration >= minDuration && meetingDuration <= maxDuration;
  }


  handleDisable(
    dayCountControl: FormControl,
    weekDayControl: FormControl,
    weekOrderControl: FormControl,
    monthOfYearControl: FormControl,
    monthOfYearAltControl: FormControl
  ): void {
    dayCountControl.disable();
    weekDayControl.disable();
    weekOrderControl.disable();
    monthOfYearControl.disable();
    monthOfYearAltControl.disable();
  }

  patchSchedilerMeetingDetails(): void {
    this.laodingService.show();
    this.providerManagementService
      .getPAMeeting(this.meetingSk)
      .pipe(
        takeUntil(this.componentDestroyed),
        finalize(() => this.laodingService.hide())
      )
      .subscribe({
        next: (res: IProviderMeetingDetails) => {
          if (res) {
            this.editMandateIds = res?.Mandates;
            const formJSONData: string = res.MeetingJson;
            const parsedData: IProviderMeetingDetails =
              JSON.parse(formJSONData);
            this.meetingDetails = parsedData;
            const parsedStartDate = this.parseDate(this.meetingDetails.startDate);
            if (this.isEditingSession === false) {
              if (parsedStartDate) {
                this.scheduleDetailsForm
                  .get('startDate')
                  ?.setValue(parsedStartDate, { emitEvent: false });
                this.cdRef.markForCheck();
              }
            }

            this.providerManagementService.bindScheduleDetails$.subscribe((details: any) => {
              if (details) {
                const scheduleTimeFormModel: ScheduleTimeRequestModel =
                  new ScheduleTimeRequestModel({
                    ...parsedData,
                    dragedStartDate: details.start,
                    dragedStartTime: details.start,
                    dragedEndTime: details.end,
                    addSelectionToGroup: this.addSelectionToGroup,
                    selectedMandatesDetails: this.selectedMandatesDetails,
                    recurringMeetingSk: this.recurringMeetingSk,
                  });
                this.scheduleDetailsForm.patchValue(scheduleTimeFormModel);

              } else {
                this.providerManagementService.bindSelectedScheduleDetails$.subscribe(data => {
                  if (data) {
                    this.scheduleDetailsForm.patchValue({
                      ...data,
                      serviceType: parsedData?.serviceType?.id
                    })

                  } else {
                    const scheduleTimeFormModel: ScheduleTimeRequestModel =
                      new ScheduleTimeRequestModel({
                        ...parsedData,
                        dragedStartDate: this.isEditingSession ? this.startDate : parsedStartDate,
                        dragedStartTime: this.startTime,
                        dragedEndTime: this.endTime,
                        addSelectionToGroup: this.addSelectionToGroup,
                        selectedMandatesDetails: this.selectedMandatesDetails,
                        recurringMeetingSk: this.recurringMeetingSk,
                      });

                    this.scheduleDetailsForm.patchValue(scheduleTimeFormModel);
                  }

                })

              }
            });

          }
        },
      });
  }
  public getToday(): Date {
    const d: Date = new Date();
    d.setHours(0, 0, 0, 0); // IMPORTANT: remove time
    return d;
  }
  get satrtDates(): Date {
    const d: Date = new Date(this.startDate);
    d.setHours(0, 0, 0, 0);
    return d;
  }
  get startTimes(): Date | null {
    const time = this.scheduleDetailsForm.get('startTime')?.value || null;
    if (time && this.shouldRestrictTime) {
      const hours = time.getHours();
      if (hours < 6) return this.minTime();
      if (hours > 22) return this.maxTime();
    }
    return time;
  }

  get endTimes(): Date | null {
    const time = this.scheduleDetailsForm.get('endTime')?.value || null;
    if (time && this.shouldRestrictTime) {
      const hours = time.getHours();
      if (hours < 6) return this.minTime();
      if (hours > 22) return this.maxTime();
    }
    return time;
  }

  get shouldRestrictTime(): boolean {
    return this.fromEncounterAttendance;
  }

  public minTime(): Date {
    const today = new Date();
    today.setHours(6, 0, 0, 0);  // 6 AM
    return today;
  }

  public maxTime(): Date {
    const today = new Date();
    today.setHours(22, 0, 0, 0); // 10 PM
    return today;
  }

  studentMandateDetails(
    languageControl?: FormControl,
    serviceTypeControl?: FormControl,
    groupSizeControl?: FormControl,
    providerAgencyControl?: FormControl
  ): void {
    this.laodingService.show();
    if (this.isSchedulerAdd) {
      this.selectedMandates = this.selectedMandatesDetails;
    }
    const mandateSks: string[] = this.selectedMandates
      ?.filter((res: DashboardPMResponse) => !!res.mandateSk)
      ?.map((res: DashboardPMResponse) => res.mandateSk);
    const studentSks: string[] = this.selectedMandates
      ?.filter((res: DashboardPMResponse) => !!res.studentSK)
      ?.map((res: DashboardPMResponse) => res.studentSK);
      const AssessmentSk: string[] =  this.selectedMandates ? this.selectedMandates?.map(
        (res: DashboardPMResponse) => {
          return res.mandateUniqueSK;
        }
      ) : [];

    const payload: IMatchingDetailsPayload = {
      providerSk: this.user.providerSk,
      mandateSks: mandateSks,
      studentSks: studentSks,
      assignmentSks: AssessmentSk
    };
    if (this.selectedMandates && this.isNew) {
      const languageDetails: number = head(
        this.selectedMandates
      )?.mandateLanguageID;
      const langauge: IReferenceData[] = this.selectAllLanguages?.filter(
        (data: IReferenceData) => data?.id === languageDetails
      );
      languageControl?.setValue(head(langauge));
      languageControl?.disable();
      const serviceDetails: number = head(this.selectedMandates)?.serviceTypeID;
      const serviceType: IReferenceData[] = this.serviceTypeAgencies?.filter(
        (data: IReferenceData) => data?.id === serviceDetails
      );
      serviceTypeControl?.setValue(head(serviceType));
      serviceTypeControl?.disable();
      const groupSizeValues = this.selectedMandates
        ?.map((mandate: DashboardPMResponse) => Number(mandate?.groupSize))
        .filter((value: number) => !Number.isNaN(value) && value > 0);
      const groupSizeDetails: string = groupSizeValues?.length
        ? String(Math.min(...groupSizeValues))
        : head(this.selectedMandates)?.groupSize?.toString() ?? '';
      groupSizeControl?.setValue(groupSizeDetails);
      if (
        groupSizeDetails !== null &&
        groupSizeDetails !== undefined &&
        groupSizeDetails !== '' &&
        Number(groupSizeDetails) !== 0
      ) {
        groupSizeControl?.disable();
      } else {
        groupSizeControl?.enable();
      }
    }
    else {
      serviceTypeControl?.disable();
      languageControl?.disable();
      groupSizeControl?.disable();
    }
    this.providerManagementService
      .getStudentMandateDetails(payload)
      .pipe(
        takeUntil(this.componentDestroyed),
        finalize(() => this.laodingService.hide())
      )
      .subscribe({
        next: (res: GetMatchingSchedulesResponse[]) => {
          this.macthedStudentDetails = head(res);
          this.mandateInfo.emit(this.macthedStudentDetails);
          //Prepopulate student/mandates
          languageControl?.setValue(this.macthedStudentDetails?.language);
          serviceTypeControl?.setValue(this.macthedStudentDetails?.serviceType);
          // if (this.macthedStudentDetails?.groupSize)
          // groupSizeControl?.setValue(this.macthedStudentDetails?.groupSize);
          // providerAgencyControl?.setValue(
          //   this.macthedStudentDetails.providerAgency
          // );
        },
      });
  }
  getProviderAgencies(): void {
    this.laodingService.show();

    this.providerManagementService
      .getAgencyProvider(this.user.providerSk)
      .pipe(
        takeUntil(this.componentDestroyed),
        finalize(() => this.laodingService.hide())
      )
      .subscribe({
        next: (res: IReferenceData[]) => {
          this.providerAgencies = res;
          this.scheduleDetailsForm.get('providerAgency').setValue(head(res));
        },
      });
  }



  initializeForm(): FormGroup {
    return (this.scheduleDetailsForm = this.formBuilder.group({
      sessionType: new FormControl(null),
      providerAgency: new FormControl(null),
      serviceType: new FormControl(null),
      language: new FormControl(null),
      groupSize: new FormControl(null),
      makeupSession: new FormControl(false),
      startDate: new FormControl(null),
      startTime: new FormControl(null),
      endTime: new FormControl(null),
      occurences: new FormControl(null),
      weekDayChip: new FormControl([]),
      studentMandates: new FormControl([]),
      locationType: new FormControl(null),
      location: new FormControl(null),
      floorRoom: new FormControl(null),
      teamsMeeting: new FormControl(false),
      // travelMethod: new FormControl(null),
      minutes: new FormControl(null),
      additionalInfo: new FormControl(null),
      occurencesCount: new FormControl(null),
      repeatUntilCount: new FormControl(null),
      repeatUntil: new FormControl(null),
      yearlyOption: new FormControl(null),
      monthOfYear: new FormControl(null),
      dayOfMonth: new FormControl(null),
      weekOrder: new FormControl(null),
      monthOfYearAlt: new FormControl(null),
      monthlyOption: new FormControl(null),
      weekDay: new FormControl(null),
      endByDate: new FormControl(null),
      dayCount: new FormControl(null),
      students: new FormControl([]),
      requiredAttendees: new FormControl([]),
      optionalAttendees: new FormControl([]),
      trainingDescription: new FormControl(),
      submission: new FormControl(null),
      locationKey: new FormControl(null),
      weekly: new FormControl(null),
    }));
  }

  onLocationTypeChange(locationType: IReferenceData): void {
    if (!locationType) {
      this.scheduleDetailsForm.get('location')?.reset();
      return;
    }
    if (
      locationType.id === this.schoolNumber ||
      locationType.id === this.studentNumber
    ) {
      const selectedStudentSk: string[] =
        this.scheduleDetailsForm.get('students')?.value?.length > 0 ?
          this.scheduleDetailsForm.get('students')?.value.map((s) => s.studentSK) :
          this.editSelectedMandates?.length > 0 ? this.editSelectedMandates.map((m) => m.studentSK)
            : this.selectedMandates?.map(m => m.studentSK) ?? [];

      if (!selectedStudentSk.length) {
        this.scheduleDetailsForm.get('location')?.reset();
        return;
      }

      const payload: getStudentSchoolAddressModel = {
        studentSks: selectedStudentSk,
        locationType: locationType.id,
      };

      this.laodingService.show();

      this.providerManagementService
        .getStudentSchoolAddress(payload)
        .subscribe((data) => {
          this.handleStudentOrSchoolAddress(locationType.id, data);
          this.laodingService.hide();
          this.cdRef.markForCheck();
        });

      return;
    }

    if (locationType.id === this.providerAgencyType) {
      this.laodingService.show();

      this.providerManagementService
        .getProviderAgencyAddress(this.user?.providerSk)
        .subscribe((address: string) => {
          this.scheduleDetailsForm.get('location')?.setValue(address || null);
          this.laodingService.hide();
          this.cdRef.markForCheck();
        });

      return;
    }

    this.scheduleDetailsForm.get('location')?.reset();
  }

  private handleStudentOrSchoolAddress(
    locationTypeId: any,
    data: any
  ): void {
    const locationControl = this.scheduleDetailsForm.get('location');
    const parts: string[] = [];
    if (locationTypeId === this.schoolNumber) {
      const enrollment = data?.enrollment ?? {};
      const address = enrollment?.address ?? {};

      if (enrollment.adminSchoolDBN || enrollment.adminSchoolName) {
        parts.push(
          `${enrollment.adminSchoolDBN ? `[${enrollment.adminSchoolDBN}] ` : ''}${enrollment.adminSchoolName ?? ''}`.trim()
        );
      }
      if (enrollment.adminSchoolDBN) {
        this.scheduleDetailsForm.get('locationKey').setValue(enrollment.adminSchoolDBN)
      }
      if (address.streetAddress1) parts.push(address.streetAddress1);
      if (address.city) parts.push(address.city);
      if (address.stateName) parts.push(address.stateName);
      if (address.zip || address.zipCode)
        parts.push(address.zip ?? address.zipCode);
    }

    else if (locationTypeId === this.studentNumber) {
      const address = data?.studentAddress ?? {};

      if (address.streetAddress1) parts.push(address.streetAddress1);
      if (address.city) parts.push(address.city);
      if (address.stateName) parts.push(address.stateName);
      if (address.zip || address.zipCode)
        parts.push(address.zip ?? address.zipCode);
    }
    const formattedAddress = parts.filter(Boolean).join(', ');

    if (formattedAddress) {
      locationControl?.setValue(formattedAddress, {
        emitEvent: false,
        onlySelf: true,
      });
    } else {
      locationControl?.setValue(null, {
        emitEvent: false,
        onlySelf: true,
      });
    }

    locationControl?.markAsDirty();
    locationControl?.markAsTouched();

    this.cdRef.markForCheck();

  }
  selectedWeekChipChange(e: number[]): void {

    if (e.length === 0) {
      if (this.scheduleDetailsForm.get('occurences')?.value?.id === 4) {
        this.showError = true;
        this.providerManagementService.setIsWeekySelected(true);
      }
    } else {
      this.showError = false;
      this.providerManagementService.setIsWeekySelected(false);
    }
    // Map chip indices (0-6) to WeekDays enum values (1-7)
    const weekDayValues: number[] = e.map(
      (i: number) => i + this.indexNumberOne
    );
    this.scheduleDetailsForm.get('weekDayChip')?.setValue(weekDayValues);

  }

  override afterOnDestroy(): void {
    //Hndle Cleanup
  }
  customFaIcon(icon: IconDefinition): SVGIcon {
    // FontAwesome icon structure: [width, height, horizontalAlign, verticalAlign, pathData]
    if (!icon || !icon.icon) {
      return {
        name: 'unknown',
        content: '<path d="" />',
        viewBox: '0 0 512 512',
      };
    }

    const defaultViewBoxSize: number = 512;
    const heightIndex: number = 1;
    const pathIndex: number = 4;

    const width: number = (icon.icon[0] as number) || defaultViewBoxSize;
    const height: number =
      (icon.icon[heightIndex] as number) || defaultViewBoxSize;
    const pathData: string = (icon.icon[pathIndex] as string) || '';

    return {
      name: icon.iconName || 'icon',
      content: `<path d="${pathData}" />`,
      viewBox: `0 0 ${width} ${height}`,
    };
  }
  /**
   * Return validation status and message for a given logical field name.
   * Looks for validation info returned from matching service (`macthedStudentDetails.validation`)
   * and falls back to reactive form control validity when available.
   */
  public getFieldValidation(field: string): {
    status: 'ok' | 'error' | null;
    message?: string;
  } {
    try {
      const remoteValidation = (this.macthedStudentDetails as any)?.validation;
      if (remoteValidation && remoteValidation[field]) {
        const entry = remoteValidation[field];
        // Expecting shape like: { isValid: boolean, message: string }
        if (typeof entry.isValid === 'boolean') {
          return {
            status: entry.isValid ? 'ok' : 'error',
            message: entry.message,
          };
        }
        // If entry is a simple string message, treat as error
        if (typeof entry === 'string') {
          return { status: 'error', message: entry };
        }
      }

      // Fallback to form control validity
      const control = this.scheduleDetailsForm?.get(field as string);
      if (control) {
        if (control.valid) return { status: 'ok' };
        // only show error if user interacted or value exists
        if (
          control.invalid &&
          (control.touched || control.dirty || control.value)
        ) {
          return { status: 'error', message: 'Invalid value' };
        }
      }
    } catch (e) {
      // ignore and return null status
    }
    return { status: null };
  }

  getReferenceData(): void {
    combineLatest([
      this.referenceStore.occurences$,
      this.referenceStore.sessionType$,
    ])
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        ([occurences, sessionType]: [IReferenceData[], IReferenceData[]]) => {
          this.referenceData.occurences = occurences || [];
          const awaitingServiceConfirmSection: boolean =
            this.providerManagementInfo?.statusID ===
            MANDATE_STATUS.AwaitingServiceConfirmation;
          const receivingConfirmSection: boolean =
            this.providerManagementInfo?.statusID === MANDATE_STATUS.Receiving;
          const allMandatesSection: boolean =
            this.providerManagementInfo?.statusID === MANDATE_STATUS.AllMandates;
          // Only restrict session types to Direct (id=1) when mandates are selected in AwaitingServiceConfirmation
          // When no mandates are selected (displayScheduleTimeButton=false), show all session types for flexibility
          if ((awaitingServiceConfirmSection || receivingConfirmSection || allMandatesSection) && this.indirectType) {
            this.referenceData.sessionType = sessionType.filter((m: IReferenceData) => m.id === 1);
            this.scheduleDetailsForm
              .get('sessionType')
              .setValue(head(this.referenceData.sessionType));
          } else {
            this.referenceData.sessionType = sessionType.filter((m: IReferenceData) => m.id !== 1);;
          }

          this.updateFilteredSessionTypes();
          this.initWatches();
          // Ensure placeholder shows for new forms: do not carry any pre-set sessionType
        }
      );
  }

  //Preventing open state of student/ mandates multiselect
  onOpen(event: PreventableEvent): void {
    event.preventDefault();
  }

  public itemDisabled(itemArgs: { index: number }): boolean {
    return itemArgs.index === this.negativeIndex;
  }
  onMinutesInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, '');
    if (input.value.length > 4) {
      input.value = input.value.slice(0, 4);
    }
  }
  confirmPastStartDate(): void {
    if (this.pendingStartDate) {
      this.scheduleDetailsForm
        .get('startDate')
        ?.setValue(this.pendingStartDate, { emitEvent: false });

      this.previousStartDate = this.pendingStartDate;
    }

    this.pendingStartDate = null;
    this.showWarningDialog = false;
  }
  onStartDateDialogClose(): void {
    this.pendingStartDate = null;
    this.showWarningDialog = false;
  }
  get isTimeSpentEnteringNotes(): boolean {
    const sessionTypeValue = this.scheduleDetailsForm.get('sessionType')?.value;
    const sessionTypeId = typeof sessionTypeValue === 'object' ? sessionTypeValue?.id : sessionTypeValue;
    return (
      sessionTypeId ===
      SessionType.TimeSpentEnteringSessionNotes
    );
  }

  get isTimeSpentSessionNotes(): boolean {
    const sessionTypeValue = this.scheduleDetailsForm.get('sessionType')?.value;
    const sessionTypeId = typeof sessionTypeValue === 'object' ? sessionTypeValue?.id : sessionTypeValue;
    return sessionTypeId === this.timeSpentEnteringSessionNotes;
  }

  get isProgressReportingSession(): boolean {
    const sessionTypeValue = this.scheduleDetailsForm.get('sessionType')?.value;
    const sessionTypeId = typeof sessionTypeValue === 'object' ? sessionTypeValue?.id : sessionTypeValue;
    return sessionTypeId === this.timeSpentProgressReporting;
  }
  get hasServiceType3Or4(): boolean {
    return this.selectedMandates?.some(
      m => m.serviceTypeID === ServiceType.SignLanguageInterpreter || m.serviceTypeID === ServiceType.OralTransliterator
    );
  }

}
